//Provider Service 중 유저 정보 읽어오기

import axios from '@core_utils/api/_axios.js'
import commonLogout from '@core_utils/common-logout';

const campaign_users = {
    namespaced: true,
    state: {
        users_in_company : []
    },
    getters: {},
    mutations: {
        update_users_in_company(state, new_users){
            state.users_in_company = new_users
        }
    },
    actions: {
        async readUsersByCompany({ commit }, company_id) {
            try {
                const response = await axios.get('/read_users_by_company', {
                    params : { company_id }
                })
                commit('update_users_in_company', response.data.all_users)    
            } catch (error) {
                if (error.response) {
                    if (error.response.status === 401) {
                        await commonLogout()
                    }
                }
            }
            
        }
    }
}


export default campaign_users